export var COLOR_POPOVER_PROPS = {
  className: 'components-custom-gradient-picker__color-picker-popover',
  position: 'top'
};
export var GRADIENT_MARKERS_WIDTH = 18;
export var INSERT_POINT_WIDTH = 23;
export var MINIMUM_ABSOLUTE_LEFT_POSITION = 5;
export var MINIMUM_DISTANCE_BETWEEN_INSERTER_AND_POINT = 10;
export var MINIMUM_DISTANCE_BETWEEN_POINTS = 0;
export var MINIMUM_SIGNIFICANT_MOVE = 5;
export var KEYBOARD_CONTROL_POINT_VARIATION = MINIMUM_DISTANCE_BETWEEN_INSERTER_AND_POINT;
export var MINIMUM_DISTANCE_BETWEEN_INSERTER_AND_MARKER = (INSERT_POINT_WIDTH + GRADIENT_MARKERS_WIDTH) / 2;
//# sourceMappingURL=constants.js.map